module.exports = __webpack_public_path__ + "static/media/speechbubble2.32df9f0b.svg";